export default __webpack_public_path__ + "static/media/eye.f0020ffe.svg";